import { createContext, useContext, useEffect, useReducer } from 'react';
import { useParams } from 'react-router-dom';
import { CustomPageCreateEditState, CustomPageCreateEditReducer, ACTION_TYPES } from './custom-page-create-edit-reducer';

const CustomPageCreateEditContext = createContext<CustomPageCreateEditState | undefined>(undefined);
const CustomPageCreateEditDispatchContext = createContext({} as any);

const CustomPageCreateEditProvider = ({ children }: { children: React.ReactNode }) => {
    const { customPageId } = useParams();
    const initialState: CustomPageCreateEditState = {
        customPageId,
        pageRequest: {},
        sections: [],
        showValidationErrors: false,
        sectionDrawer: { open: false },
        itemDrawer: { open: false },
    };
    const [state, dispatch] = useReducer(CustomPageCreateEditReducer, initialState);

    // Após criar a página a rota muda para /editar/:id reaproveitando este provider
    useEffect(() => {
        if (customPageId !== state.customPageId) {
            dispatch({ type: ACTION_TYPES.setCustomPageId, payload: customPageId });
        }
    }, [customPageId, state.customPageId]);
    return (
        <CustomPageCreateEditContext.Provider value={state}>
            <CustomPageCreateEditDispatchContext.Provider value={dispatch}>
                {children}
            </CustomPageCreateEditDispatchContext.Provider>
        </CustomPageCreateEditContext.Provider>
    );
};

const useCustomPageCreateEditState = () => {
    const context = useContext(CustomPageCreateEditContext);
    if (!context) throw new Error('useCustomPageCreateEditState must be used within CustomPageCreateEditProvider');
    return context;
};

const useCustomPageCreateEditDispatch = () => {
    const context = useContext(CustomPageCreateEditDispatchContext);
    if (!context) throw new Error('useCustomPageCreateEditDispatch must be used within CustomPageCreateEditProvider');
    return context;
};

export { CustomPageCreateEditProvider, useCustomPageCreateEditState, useCustomPageCreateEditDispatch, ACTION_TYPES };
